<template>
  <div class="home-container">
     <div class="menu">
       <div v-for="(items,i) in list" :key="i">
          <h3 v-if="i==0" class="lawResult-right-item-title word-middle" 
              >中国人民共和国刑法</h3>
          <h3 v-else-if="i==1" class="lawResult-right-item-title word-middle"
            >中国人民共和国刑事诉讼法</h3>
          <h3 v-else-if="i==2" class="lawResult-right-item-title word-middle">中国人民共和国监察法</h3>
              <el-menu default-active="2" v-for="(item,index) in items" :key="index">
                <el-submenu :index="i+''">
                    <template slot="title">
                      <span style="font-weight:bold" v-html="item.name.replace('　',' ')"></span>
                    </template>
                    <el-submenu v-if="i!=2"  v-for="(col,idx) in item.children" :key="idx" :index="i+'-'+idx">
                      <template slot="title" >
                        <span  class="word-color1" v-html="col.name.replace('　',' ')"></span>
                      </template>
                        <el-menu-item  v-for="(val,i) in col.children" :index="i+'-'+idx + '-'+i" :key="i" @click="navFn(val.name, val.id)">
                            <el-tooltip class="item" transition="" popper-class="tool-tip" effect="dark" :content="val.name" placement="right-start">
                                <span class="overflow-ellipsis" v-html="val.name.replace('　',' ')"></span>
                            </el-tooltip>
                        </el-menu-item>
                    </el-submenu>

                    <el-menu-item v-if="i==2" v-for="(val,k) in item.children" :index="i+ '-' + '-'+k" :key="k" @click="navFn(val.name, val.id)">
                        <el-tooltip class="item" transition="" popper-class="tool-tip" effect="dark" :content="val.name" placement="right-start">
                            <span class="overflow-ellipsis" v-html="val.name.replace('　',' ')"></span>
                        </el-tooltip>
                    </el-menu-item>
                </el-submenu>
              </el-menu>

        </div>
     </div>
     <div class="result criminal-result" :style="editableTabs.length == 0?'background:#fff;border: 1px solid #B1CFE7':''">
       <div :key="item.name"  v-for="(item) in editableTabs">
          <keep-alive>
            <law-page :selected="item.name == editableTabsValue" v-if="item.name == editableTabsValue" :param="item.title" :clId="item.clId"></law-page>
          </keep-alive>
       </div>
       <!-- <el-tabs v-if="editableTabs.length > 0" v-model="editableTabsValue" class="result-tab-pane"  type="card" closable @tab-remove="removeTab">
        <el-tab-pane
          :key="item.name"
          v-for="(item) in editableTabs"
          :name="item.name">
            <span slot="label" class="overflow-ellipsis">
               <el-tooltip class="item" effect="dark" :content="item.title" placement="bottom-start">
                <span>
                  <span v-if="!item.clId">搜索内容：</span>
                  {{item.title}}
                </span>
               </el-tooltip>
            </span>
          <keep-alive>
             <criminal :selected="item.name == editableTabsValue" v-if="item.name == editableTabsValue" :param="item.title" :clId="item.clId"></criminal>
          </keep-alive>
        </el-tab-pane>
       </el-tabs> -->

       <!-- <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
        <li @click="closeAllTags()">关闭全部</li>
      </ul>
        <div v-if="editableTabs.length == 0">
          <div class="tip-head"></div>
          <div class="operation-tip">
              <p class="word-big tip-title">【温馨提示】</p>
              <span style="color:#5C79B0" class="word-middle">以下是刑事审判参考汇编之查询方式，敬请使用！</span>
              <div class="way-pic">
                <div class="way">
                  <p class="word-normal" style="color:#5C79B0;margin: 15px 0">【方式一】</p>
                  <p class="word-middle" style="color:#165AC6;margin: 15px 0">点击“左边菜单栏”按法条目录查询</p>
                  <div class="way-img"><img src="../../assets/search_tip_left.png" alt=""></div>
                </div>
                <div class="way">
                  <p class="word-normal" style="color:#5C79B0;margin: 15px 0">【方式二】</p>
                  <p class="word-middle" style="color:#165AC6;margin: 15px 0">点击顶部“搜索框”搜索查询</p>
                  <div class="way-img"><img src="../../assets/search_tip_right.png" alt=""></div>
                </div>
              </div>
          </div>
       </div> -->
     </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Criminal from '@/views/criminal/index'
export default {
  data () {
    return {
      list:[],
      editableTabsValue: '',
      editableTabs: [],
      left: 0,
      top: 0,
      visible: false,
      version: window.version
    };
  },

  components: {Criminal},

  mounted(){
    var criminalList = JSON.parse(sessionStorage.getItem('criminalList'));
    if(criminalList){
      criminalList.forEach((v,i)=>{
        this.editableTabs.push({
          title: v.param,
          name: v.name,
          clId: v.clId
        })
      })
    }
    var find = _.find(this.editableTabs,{title: this.$route.query.param})
    if(this.$route.query.create && !find){
      this.editableTabs.push({
        title: this.$route.query.param,
        name: Date.now() + Math.random().toString(36).substr(2)
      })
    }
    this.fetchData()
    if(this.editableTabs.length>0){
      this.editableTabsValue = sessionStorage.getItem('editableTabsValue')
      if(!this.editableTabsValue){
        this.editableTabsValue = this.editableTabs[0].name;
      }
    }
  },
  watch:{
    $route:function(val){
      if(val && val.query.create){
        this.editableTabsValue = Date.now() + Math.random().toString(36).substr(2);
        this.editableTabs.push({
          title: this.$route.query.param,
          name: this.editableTabsValue,
          clId: this.$route.query.clId
        })

        sessionStorage.setItem('editableTabsValue',this.editableTabsValue)
      }
    },
    editableTabsValue:function(val){
        if(val){
          sessionStorage.setItem('editableTabsValue',val)
        }
    }
  },

  methods: {
    fetchData(){
      let lawList = sessionStorage.getItem('clause');
      if(lawList && lawList!==undefined && lawList!==null){
        this.list = JSON.parse(lawList)
      }else{
        this.httpGet('law/laws/clause', {}, false).then(res => {
          if (res.statusCode === 1) {
            this.list = [res.data.criminalLaw,res.data.proceduralLaw]
            if(this.version !== 'procuratorate'){
              this.list.push(res.data.procurationLaw)
            }
            sessionStorage.setItem('clause',JSON.stringify(this.list));
          } else {
            this.$message(res.message)
          }
        })
      }
    },
    navFn(name, id){
      this.$router.push({
        path: '/criminal/home',
        query: {
          param: name,
          clId: id,
          create: true
        }
      })

      let criminalList = JSON.parse(window.sessionStorage.getItem("criminalList"))
        if(criminalList == null){
          criminalList = []
        }
        var find  = _.find(criminalList,{clId:id})
        if(!find){
          criminalList.push({
            param: name,
            clId: id,
            name: Date.now() + Math.random().toString(36).substr(2)
          })
        }
        window.sessionStorage.setItem('criminalList',JSON.stringify(criminalList))
      
    },
    closeAllTags(){
      sessionStorage.removeItem('criminalList');
      this.editableTabs = [];
      this.$router.push({
        path: '/criminal/home'
      })
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY
      this.visible = true
      
    },
    closeMenu() {
      this.visible = false
    },
    removeTab(item){
      var index = ""
      this.editableTabs && this.editableTabs.forEach((v,i)=>{
        if(v.name == item){
          index = i;
        }
      })
      if(index!==""){
        var criminalList = JSON.parse(sessionStorage.getItem('criminalList'));
        var key = "";
        criminalList && criminalList.forEach((v,i)=>{
          if(v.param == this.editableTabs[index].title){
            key = i;
          }
        })
        if(key!==""){
          criminalList.splice(key, 1)
          sessionStorage.setItem('criminalList',JSON.stringify(criminalList))
        }
        if(this.$route.query.param == this.editableTabs[index].title){
          this.$router.push({
            path: '/criminal/home'
          })
        }

        this.editableTabs.splice(index,1);
        if(this.editableTabs.length>0){
          this.editableTabsValue = this.editableTabs[this.editableTabs.length-1].name;
        }else{
          this.$router.push({
            name: '/criminal/home'
          })
          this.$router.go(0)
          sessionStorage.removeItem('editableTabsValue')
        }
      }
    }
  },
  beforeDestroy(){
    // let criminalList = JSON.parse(window.sessionStorage.getItem("criminalList"))
    // if(criminalList && criminalList.length>0){
    //   var found = _.find(this.editableTabs,{name: this.editableTabsValue})
    //   var find = _.find(criminalList,{param:found.title })
    //   if(find){
    //     sessionStorage.setItem('editableTabsValue', find.name)
    //   }else{
    //     sessionStorage.setItem('editableTabsValue', criminalList[criminalList.length-1].name)
    //   }
    // }
  }
}

</script>
<style scoped lang="less">
.home-container{
  margin: 10px;
  display: flex;
  justify-content: space-between;
  overflow-x: hidden;
}
.menu{
  width: 210px;
  min-width: 210px;
  margin-right: 10px;
  background:rgba(255,255,255,1);
  border:1px solid @lineColor;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 10px;
  height: calc(100vh - 94px);
}
.overflow-ellipsis{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  display: block;
  color: @wordColor2;
  padding-right: 20px;
}
.lawResult-right-item{
  margin-top: 20px;
  background: #fff;
  padding: 16px 0px;
  box-shadow: 0px 4px 5px 0px rgba(118, 118, 118, 0.08);
  overflow-y: auto;
  overflow-x: hidden;
}
.lawResult-right-item-title{
  color: @wordColor1;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
}

.last-item-color{
  color:@wordColor2;
}


.result{
  width: 800px;
  flex: 1;
  position: relative;
}

.tip-head{
  width: 100%;
  height: 35px;
  background: @headerColor;
}
</style>



// WEBPACK FOOTER //
// src/views/criminal/home.vue